import './orientation.css';
import ipadRotateImgUrl from '/src/assets/ipad-with-arrow-whitebg.svg';

const OrientationWarning = () => {
  return (
    <div className="flex flex-col justify-center items-center absolute top-0 left-0 h-screen w-screen bg-black">
      <div className="ipad-container">
        <img src={ipadRotateImgUrl} alt="Orientation Warning" />
      </div>
      <div>
        <h1 className="text-3xl font-bold py-20 text-white">ポートレートモードは不可。</h1>
      </div>
    </div>
  );
};

export default OrientationWarning;
